import React from "react";

function SocialDetails(props) {
  console.log(props.item);
  return (
    <div>
      <div className="text-center">
        <h3>{props.item.title} </h3>
        <img
          style={{ margin: "8% 0%", width: "100%" }}
          src={props.item.image}
          alt=""
        />
        <p>{props.item.smellDescription}</p>
        <h5 className="text-left my-2">{props.item.subtitle}</h5>
        <p className="text-left">{props.item.largeDescription}</p>
        <h6 className="text-right">
          {" "}
          date: {props.item.date_day} {props.item.month_name}
        </h6>
      </div>
    </div>
  );
}

export default SocialDetails;
